/** Endpoints #20-#21 — app settings read/write. Scraper config lives at #35-#38. */

import type { SettingsResponse, SettingsUpdateBody } from '@lw/shared';
import { apiJson } from './client';

/** #20 `GET /api/settings` */
export function getSettings(signal?: AbortSignal): Promise<SettingsResponse> {
  return apiJson<SettingsResponse>('/settings', { signal });
}

/** #21 `PUT /api/settings` — partial update; the server owns the reschedule/recompute effects. */
export function updateSettings(body: SettingsUpdateBody): Promise<SettingsResponse> {
  return apiJson<SettingsResponse>('/settings', { method: 'PUT', body });
}
